export const filterValueToLabelMapping = {
  name: "Name",
  employee_id: "Employee ID",
  email: "Email",
  employee_type: "Employee Type",
  department: "Department",
  branch: "Branch",
  employee_grade: "Employee Grade",
  pin: "Pin",
  address: "Address",
  birthday: "Birthday",
  account_number: "Account Number",
  account_name: "Account Name",
  bank: "Bank",
  salutation: "Salutation",
  genotype: "Genotype",
  mobile_number: "Mobile Number",
  local_government: "Local Government",
  city: "City",
  state: "State",
  country: "Country",
  appointment_date: "Employment Date",
  blood_group: "Blood Group",
  date_of_birth: "Date Of Birth",
  nationality: "Nationality",
  religion: "religion",
  marital_status: "Marital Status",
  show_in_organogram: "Show_In_Organogram",
  employee_category: "Employee Category",
  employee_designation: "Employee Designation",
  bank_branch: "Bank Branch",
  pension_fund_administrator: "PFA",
  rsa_pin: "RSA Pin",
  tax_id: "Tax Id",
};

export const filterLabelToValueMapping = {
  Name: "name",
  "Employee ID": "employee_id",
  Email: "email",
  "Employee Type": "employee_type",
  Department: "department",
  Branch: "branch",
  "Employee Grade": "employee_grade",
  Pin: "pin",
  Address: "address",
  Birthday: "birthday",
  "Account Number": "account_number",
  "Account Name": "account_name",
  Bank: "bank",
  Salutation: "salutation",
  Genotype: "genotype",
  "Mobile Number": "mobile_number",
  "Local Government": "local_government",
  city: "City",
  State: "state",
  Country: "country",
  "Employment Date": "appointment_date",
  "Blood Group": "blood_group",
  "Date Of Birth": "date_of_birth",
  Nationality: "nationality",
  Religion: "religion",
  "Marital Status": "marital_status",
  "Show In Organogram": "show_in_organogram",
  "Employee Category": "employee_category",
  "Employee Designatiom": "employee_designatiom",
  "Bank Name": "bank",
  "Bank Branch": "bank_branch",
  PFA: "pension_fund_administrator",
  "RSA Pin": "rsa_pin",
  "Tax Id": "tax_id",
};

export const otherFiltersValueToLabelMapping = {
  company: "All Users",
  branch: "By Branch",
  department: "By Department",
  employee: "By Individuals",
};
